import createMuiTheme from "@material-ui/core/styles/createMuiTheme";

export function createTheme() {
    return createMuiTheme({
        palette: {
            primary: {
                main: "#FFB81C"
            },
            secondary: {
                main: "#0AA1D7"
            }
        },
        overrides: {
            MuiLink: {
                root: {
                    color: "#337ab7"
                }
            },
            MuiTextField: {
                root: {
                    margin: "0.5rem 0"
                }
            },
            MuiButton: {
                root: {
                    margin: "0.5rem 0"
                }
            },
            MuiTableCell: {
                sizeSmall: {
                    lineHeight: 1.5,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            },
            MuiTab: {
                root: {
                    minWidth: 0
                },
                labelIcon: {
                    minHeight: 0
                },
                wrapper: {
                    flexDirection: "row",
                    alignItems: "stretch",
                    "& > *:first-child": {
                        marginRight: "0.2rem"
                    }
                }
            }
        }
    })
}